import React from 'react';
import IconUtil from '../util/icon-util';
import {BsFillChatDotsFill} from 'react-icons/bs';
import {AiTwotoneHeart} from 'react-icons/ai';
import {Link} from 'gatsby';
import Tooltip from '../util/tooltip';
export default function Footer(props) {
  return props.data == null ? null : (
        <div className=" w-11/12 mx-auto pb-16 md:w-full">
          <div className=" flex items-center justify-center w-4/5 text-center mx-auto flex-col gap-4 md:w-full md:flex-row md:gap-0">
            <div
              className={`mr-2 w-3 h-3 inline-block rounded-full ${
                        props.data.isAvailable ? 'bg-green-500' : 'bg-red-500'
              } `}
            ></div>
            <div className="font-bold text-sm tracking-wider text-gray-700 uppercase">
              {props.data.subtitle}
            </div>
          </div>
          <div className=" text-center mx-auto w-full md:w-4/5 lg:max-w-3/4 xl:max-w-1/2">
            <h2 className=" my-12 text-4xl font-semibold text-gray-900 tracking-tighter md:text-6xl md:font-bold">
              {props.data.title}
            </h2>
            <Link to="/contact">
              <button className=" mx-auto px-8 py-6 rounded-full bg-green-500 uppercase shadow-secondary text-white  relative focus:outline-none flex items-center transition-all duration-500 transform hover:-translate-y-3">
                <span className=" mr-2">
                  <BsFillChatDotsFill />
                </span>
                <span className=" font-bold text-sm tracking-wider">
                            Lets Talk Now
                </span>
              </button>
            </Link>
          </div>
          <div className=" mt-24 text-sm font-bold text-center uppercase tracking-tight text-gray-800 flex items-center justify-center">
            <div>Made with </div>
            <AiTwotoneHeart className="mx-1 text-red-600" />
            <div>using</div>
            <IconUtil className="mx-1 text-purple-700" icon="Gatsby" />
            <div> and </div>
            <IconUtil className="mx-1 text-blue-500" icon="Tailwind" />
          </div>
        </div>
    );
}
